// src/redux/helpers/api.config.ts

export const AUTH_MESSAGES = {
    LOGIN_SUCCESS: 'Successfully logged in.',
    LOGIN_ERROR: 'Invalid user credentials.',
    LOGOUT_SUCCESS: 'Successfully logged out.',
    REFRESH_SUCCESS: 'Session refreshed.',
    REFRESH_FAILED: 'Failed to refresh session.',
    REGISTER_SUCCESS: "Registration successful.",
    REGISTER_ERROR: "Registration failed.",
    SESSION_EXPIRED: 'Your session has expired. Please log in again.',
    NETWORK_ERROR: 'Network error. Please try again.',
    UNAUTHORIZED: 'Unauthorized access. Please log in.',
    FORBIDDEN: 'Access denied.',
    NOT_FOUND: 'Requested resource not found.',
    GENERIC_ERROR: 'Something went wrong. Please try again.',
    CHANGE_PASSWORD_SUCCESS: 'Password changed successfully',
    CHANGE_PASSWORD_ERROR: 'Failed to change password. Please try again.',
    RESET_SUCCESS: 'Password reset successfully. You can now log in with your new password.',
    RESET_ERROR: 'Failed to reset password. Please check your input and try again.',
} as const;

export const AUTH_ENDPOINTS = {
    LOGIN: '/auth/login',
    REFRESH: '/auth/refresh',
    REGISTER: '/auth/register',
    CHANGE_PASSWORD: '/auth/changePassword',
    RESET_PASSWORD: '/auth/resetPassword',
    FORGOT_PASSWORD: 'auth/forgotPassword',
} as const;